<ion-item-group>
  <ion-item-divider>
    <ion-label>{{ 'Mobile.OfflineMap' | translate }}</ion-label>
  </ion-item-divider>

  <ion-item [disabled]="isDownloadOverWifiSettingDisabled">
    <ion-toggle [checked]="downloadOverWifiOnly" (ionChange)="onDownloadOverWifiOnlyChange($event)">
      {{ 'Mobile.MapOfflineDownloadOverWifiOnly' | translate }}
    </ion-toggle>
  </ion-item>

  <ion-item (click)="onOfflineMapClicked()" lines="none">
    <ion-icon slot="end" name="cloud-download-outline" color="primary"></ion-icon>
    <ion-label>{{ offlineMapButtonText | translate: offlineMapButtonTextParam }}</ion-label>
  </ion-item>

  <ion-progress-bar *ngIf="hasProgress" [value]="progress"></ion-progress-bar>

  <ion-item *ngIf="isDownloadStarted" lines="none">
    <ion-col>
      <ion-button expand="block" fill="clear" (click)="onPause()">{{ pauseButtonText | translate }}</ion-button>
    </ion-col>
    <ion-col>
      <ion-button expand="block" fill="clear" (click)="onCancel()">{{ 'Mobile.Cancel' | translate }}</ion-button>
    </ion-col>
  </ion-item>
</ion-item-group>
